import { render, staticRenderFns } from "./rewardRainTab.vue?vue&type=template&id=f8d993cc&lang=pug"
import script from "./rewardRainTab.vue?vue&type=script&lang=js"
export * from "./rewardRainTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports